
import axios from 'axios'
import store from './store/state'
import * as types from './store/types'
import router from './router'
import api from './api'
// axios 配置
const request = axios.create({
    // baseURL: '', // 请求的公共地址部分
    timeout: 60000, // 请求超时时间 当请求时间超过5秒还未取得结果时 提示用户请求超时
    headers:{
        'Content-Type':'application/x-www-form-urlencoded' //body为formData格式
      }
})

// http request 拦截器
request.interceptors.request.use(
    config => {
        if (store.state.token) {
            config.headers.Authorization = `token ${store.state.token}`;
        }
        return config;
    },
    err => {
        return Promise.reject(err);
    });

// http response 拦截器
request.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    // 401 跳转到登录页面
                    store.commit(types.LOGOUT);
                    window.location.href="/login";
                    break;
            }
        }
        console.log(error)
        // console.log(JSON.stringify(error));//console : Error: Request failed with status code 402
        return Promise.reject(error)
    });

export default request;



// WEBPACK FOOTER //
// ./src/request.js